export const getObstacleImageUrl = (obstacleId: string, imageFilename?: string): string => {
  // Use the stored filename if available, otherwise default to .png
  const filename = imageFilename || `${obstacleId}.png`;
  
  // Always use the CDN URL for consistent image loading
  return `https://static.airplx.com/${filename}`;
};